export default {
  independentMarketing: {
    common: {
      requestFailed: 'Schnittstellenanforderung fehlgeschlagen',
      hintSelect: 'Auswählen',
      hintInput: 'Eingeben',
      submit: 'Absenden',
      cancel: 'Abbrechen',
      confirm: 'OK',
    },
    agreement: {
      title: 'Registrierungsvereinbarung für unabhängige Autel-Händler',
      nextBtn: 'Nächste',
      getAgreementFailed: 'Der Inhalt der Vereinbarung konnte nicht abgerufen werden.',
    },
    successPage: {
      title:
        'Ihre Bewerbungsinformationen wurden erfolgreich übermittelt und die Überprüfungsergebnisse werden innerhalb von 15 Werktagen an Ihre E-Mail-Adresse $1 gesendet. Weitere Informationen finden Sie in Ihrem Posteingang.',
      subTitle: 'Kehren Sie nach $1 Sekunde(n) zur Startseite zurück.',
    },
    applyTitle:
      'Sie bewerben sich als unabhängiger Autel-Händler. Bitte füllen Sie die folgenden Informationen korrekt aus:',
    companyName: 'Firmenname',
    companyTax: 'VAT ID',
    userCountry: 'Land',
    legalPerson: 'Rechtsbeistand',
    contactEmail: 'Kontakt E-mail',
    contactEmailTips:
      'Diese E-Mail-Adresse dient als Kontaktadresse für die E-Mail mit den Bewertungsergebnissen. Sobald die Bewertung genehmigt wurde, wird sie auch als Login-Kontoname für das unabhängige Händlerverwaltungssystem verwendet.',
    corporateIdentity: 'Rechtsberater-ID',
    uploadTips: 'JPG, JPEG, PNG, PDF (nicht größer als 20 MB)',
    businessLicense: 'Geschäftslizenz',
    emailErrorTips: 'Geben Sie eine gültige E-Mail-Adresse ein.',
    uploadPic: 'Bilder hochladen',
    picMaxLimit: 'Die maximale Bildgröße beträgt 20 MB. Bitte wählen Sie erneut aus.',
  },
};
